import { useContext } from 'react';
import ReportDataContext from '../contexts/reportDataContext';
import type { ReportDataContextType } from '../types/report';

const useReportDataContext = (): ReportDataContextType => {
  const context = useContext(ReportDataContext);
  if (!context) {
    throw new Error('useReportDataContext must be used within a ReportDataProvider');
  }
  return context;
};

export default useReportDataContext;
